<template>
  <section
    id="example"
    class="bg-co-gray-50 pb-14 pt-16 md:py-10"
    style="background: linear-gradient(180deg, #f7f9f9 0%, #f9fafa 50.52%, #fff 100%)"
  >
    <div class="co-container-xs px-7">
      <h2 class="co-heading-2-caption mb-4 text-center font-bold">
        <span class="co-display-14 mb-1 inline-block border-b pb-1 font-bold text-[#1ca7f6]">Example</span>
        <br>
        補助対象コースの<br class="block md:hidden">キャッシュバックの一例
      </h2>
      <h3 class="co-display-12 mb-14 text-center leading-normal text-co-gray-600">
        人気の講座が最大<span class="co-display-9 font-bold text-co-danger-500">70%</span>キャッシュバック
      </h3>
      <div class="mb-10 flex flex-col gap-8 md:mb-14 md:flex-row">
        <div class="flex-1 text-center">
          <h3 class="co-display-11 font-bold leading-normal text-[#1ca7f6]">
            Web制作副業から転職を目指すなら
          </h3>
          <h4 class="co-display-8 mb-4 bg-[#1ca7f6] py-5 text-center font-bold text-co-gray-50">
            はじめての副業コース
          </h4>
          <div class="flex items-baseline justify-center gap-1">
            <span class="co-mr-4 co-display-13 co-text-co-gray-600 leading-tight">8週間プラン通常</span>
            <span class="co-display-10 font-bold text-co-gray-600">{{ $addComma(firstSidejobPrices.social_8weeks.price) }}</span>
            <span class="font-bold text-co-gray-600">円</span>
            <span class="co-display-14 text-co-gray-600">（税込）</span>
            <span class="co-display-14 text-co-gray-600">のところ</span>
          </div>
          <div class="te-reskilling-examle-arrow pt-4">
            <p class="mb-2 leading-tight">
              <span class="font-bold text-co-gray-600">キャッシュバック</span>
              <span class="co-display-8 font-bold text-co-danger-500">{{ $addComma(firstSidejobPrices.social_8weeks.reskilling_refund_price) }}</span>
              <span class="font-bold text-co-danger-500">円</span>
            </p>
            <p class="leading-tight">
              <span class="co-display-8 mr-3 font-bold text-co-danger-500">最安値</span>
              <span class="co-display-1 font-bold text-co-danger-500">{{ $addComma(firstSidejobPrices.social_8weeks.reskilling_price) }}</span>
              <span class="co-display-8 font-bold text-co-danger-500">円</span>
            </p>
          </div>
        </div>
        <div class="flex-1 text-center">
          <h3 class="co-display-11 font-bold leading-normal text-[#1ca7f6]">
            人気のWebデザイナーを目指すなら
          </h3>
          <h4 class="co-display-8 mb-4 bg-[#1ca7f6] py-5 text-center font-bold text-co-gray-50">
            Webデザインコース
          </h4>
          <div class="flex items-baseline justify-center gap-1">
            <span class="co-mr-4 co-display-13 leading-tight text-co-gray-600">8週間プラン通常</span>
            <span class="co-display-10 font-bold text-co-gray-600">{{ $addComma(webdesignPrices.social_8weeks.price) }}</span>
            <span class="font-bold text-co-gray-600">円</span>
            <span class="co-display-14 text-co-gray-600">（税込）</span>
            <span class="co-display-14 text-co-gray-600">のところ</span>
          </div>
          <div class="te-reskilling-examle-arrow pt-2">
            <p class="mb-2 leading-tight">
              <span class="font-bold text-co-gray-600">キャッシュバック</span>
              <span class="co-display-8 font-bold text-co-danger-500">{{ $addComma(webdesignPrices.social_8weeks.reskilling_refund_price) }}</span>
              <span class="font-bold text-co-danger-500">円</span>
            </p>
            <p class="leading-tight">
              <span class="co-display-8 mr-3 font-bold text-co-danger-500">最安値</span>
              <span class="co-display-1 font-bold text-co-danger-500">{{ $addComma(webdesignPrices.social_8weeks.reskilling_price) }}</span>
              <span class="co-display-8 font-bold text-co-danger-500">円</span>
            </p>
          </div>
        </div>
      </div>
      <div class="mb-3 text-center">
        <p class="co-display-10 mb-2 font-bold text-co-gray-600">
          他にも、AI・プログラミングなどが
          <span class="co-display-8 block font-bold text-co-danger-500 md:inline">お得に学べる</span>
          <br class="hidden md:block">
          このチャンスをお見逃し無く
        </p>
        <div class="te-reskilling-example-tryangle mx-auto" />
      </div>
      <div class="text-center">
        <a
          class="co-btn-tertiary"
          href="/_nuxt/pdf/reskill-document.pdf"
          target="_blank"
        >
          キャッシュバック一覧表はこちら
          <FontAwesomeIcon
            :icon="faAngleRight"
            class="fa-fw inline h-4 w-5"
          />
        </a>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faAngleRight } from '@awesome.me/kit-65d95819ce/icons/classic/solid'
</script>

<script lang="ts">
import { getCourse } from '~/utility/fetchAPI'

const options = {
  filters: {
    addComma(value: number) {
      return value ? value.toLocaleString() : '-'
    },
  },
  data() {
    return {
      firstSidejob: null,
      webdesign: null,
    }
  },
  computed: {
    firstSidejobPrices() {
      return this.firstSidejob
        ? this.firstSidejob.attributes.prices
        : {
            social_8weeks: {
              price: '-',
              reskilling_price: '-',
              reskilling_refund_price: '-',
            },
          }
    },
    webdesignPrices() {
      return this.webdesign
        ? this.webdesign.attributes.prices
        : {
            social_8weeks: {
              price: '-',
              reskilling_price: '-',
              reskilling_refund_price: '-',
            },
          }
    },
  },
  mounted() {
    getCourse(this.$api, 'first-sidejob', {}).then((response) => {
      this.firstSidejob = response.data
    })
    getCourse(this.$api, 'webdesign', {}).then((response) => {
      this.webdesign = response.data
    })
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
/* 矢印 */
.te-reskilling-examle-arrow {
  background-image: url('~/assets/images/Te/TeBenefits/Reskilling/Cashback/example-arrow.svg');
  background-repeat: no-repeat;
  background-position: top -8px right 50%;
  background-size: 5rem 5.5625rem;
}

/* 矢印下の小さい方 */
.te-reskilling-example-tryangle {
  display: inline-block;
  width: 0;
  height: 0;
  border-style: solid;
  border-top: 20px solid #efefef;
  border-right: 30px solid transparent;
  border-bottom: 0;
  border-left: 30px solid transparent;
}
</style>
